import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const CollectionsContext = createContext([]);

export const CollectionsProvider = ({ children }) => {
  const [collections, setCollections] = useState([]);
  useEffect(() => {
    api.get("/collections").then((r) => setCollections(r.data)).catch(() => {});
  }, []);
  return (
    <CollectionsContext.Provider value={collections}>
      {children}
    </CollectionsContext.Provider>
  );
};

export const useCollections = () => useContext(CollectionsContext);
